/**
 * @desc 详情
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(params: API.fulfilment.inPlanMaster.getDetailByIpno.Params, options?: any) {
  return updateResponse(
    http(URL + `/inPlanMaster/getDetail`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
